import React, { useEffect, useState } from "react";
import Home from './pages/Home';
import About from './pages/About';
import Contact from './pages/Contact';
import Projects from './pages/Projects';
import VolunteerNow from "./pages/VolunteerNow";
import Farming from "./pages/Farming";
import Teaching from "./pages/Teaching";
import Health from "./pages/Health";
import Microfinance from "./pages/Microfinance";
import Events from "./pages/Events";
import EventDetail from "./pages/EventDetail";
import AdminDashboard from "./pages/Admin/AdminDashboard";
import AdminLogin from "./pages/Admin/AdminLogin";
import AdminForgotPassword from "./pages/Admin/AdminForgotPassword";
import ResetPassword from "./pages/ResetPassword";
import CreateArticle from "./pages/Admin/CreateArticle";
import EditArticleStub from "./pages/Admin/EditArticleStub";
import AdminPosts from "./pages/Admin/AdminPosts";
import EditEvent from "./pages/Admin/EditEvent";
import MediaLibrary from "./pages/Admin/MediaLibrary";
import AdminMessages from "./pages/Admin/AdminMessages";
import AdminVolunteers from "./pages/Admin/AdminVolunteers";
import Navbar from './Components/Navbar';
import { BrowserRouter, Routes, Route, useLocation, Navigate } from 'react-router-dom';
import {
  ADMIN_AUTH_FLAG_KEY,
  ADMIN_JWT_STORAGE_KEY,
  hasAdminSession,
} from "./services/authToken";

function AppLayout({ isLoggedIn }) {
    const location = useLocation();
    const isAdminRoute = location.pathname.toLowerCase().startsWith("/admin");

    const [adminAuthed, setAdminAuthed] = useState(() => hasAdminSession());

    useEffect(() => {
        setAdminAuthed(hasAdminSession());
    }, [location.pathname]);

    useEffect(() => {
        const onStorage = (e) => {
            if (
                e.key === ADMIN_JWT_STORAGE_KEY ||
                e.key === ADMIN_AUTH_FLAG_KEY ||
                e.key === null
            ) {
                setAdminAuthed(hasAdminSession());
            }
        };
        window.addEventListener("storage", onStorage);
        return () => window.removeEventListener("storage", onStorage);
    }, []);

    return (
        <>
            {!isAdminRoute && <Navbar isLoggedIn={isLoggedIn} />}
            <Routes>
                <Route path="/" element={<Home />} />
                <Route path="/About" element={<About />} />
                <Route path="/Contact" element={<Contact />} />
                <Route path="/Projects" element={<Projects />} />
                <Route path="/VolunteerNow" element={<VolunteerNow />} />
                <Route path="/Farming" element={<Farming />} />
                <Route path="/Teaching" element={<Teaching />} />
                <Route path="/Health" element={<Health />} />
                <Route path="/Microfinance" element={<Microfinance />} />
                <Route path="/Events" element={<Events />} />
                <Route path="/Events/:eventId" element={<EventDetail />} />
                <Route path="/admin/login" element={<AdminLogin />} />
                <Route path="/admin/forgot-password" element={<AdminForgotPassword />} />
                <Route path="/reset-password" element={<ResetPassword />} />
                <Route
                    path="/admin"
                    element={adminAuthed ? <AdminDashboard /> : <Navigate to="/admin/login" replace />}
                />
                <Route
                    path="/admin/articles/new"
                    element={adminAuthed ? <CreateArticle /> : <Navigate to="/admin/login" replace />}
                />
                <Route
                    path="/admin/articles/:articleId/edit"
                    element={adminAuthed ? <EditArticleStub /> : <Navigate to="/admin/login" replace />}
                />
                <Route
                    path="/admin/posts/:eventId/edit"
                    element={adminAuthed ? <EditEvent /> : <Navigate to="/admin/login" replace />}
                />
                <Route
                    path="/admin/posts"
                    element={adminAuthed ? <AdminPosts /> : <Navigate to="/admin/login" replace />}
                />
                <Route
                    path="/admin/media"
                    element={adminAuthed ? <MediaLibrary /> : <Navigate to="/admin/login" replace />}
                />
                <Route
                    path="/admin/messages"
                    element={adminAuthed ? <AdminMessages /> : <Navigate to="/admin/login" replace />}
                />
                <Route
                    path="/admin/volunteers"
                    element={adminAuthed ? <AdminVolunteers /> : <Navigate to="/admin/login" replace />}
                />
                {["analytics", "settings"].map((seg) => (
                    <Route
                        key={seg}
                        path={`/admin/${seg}`}
                        element={adminAuthed ? <AdminDashboard /> : <Navigate to="/admin/login" replace />}
                    />
                ))}
            </Routes>
        </>
    );
}

function App() {
    const isLoggedIn = true;

    return (
        <BrowserRouter>
            <AppLayout isLoggedIn={isLoggedIn} />
        </BrowserRouter>
    );
}

export default App;
